import { render, staticRenderFns } from "./GraduateApplicationStudentStatusSelectbox.vue?vue&type=template&id=b5a5defa&"
import script from "./GraduateApplicationStudentStatusSelectbox.vue?vue&type=script&lang=js&"
export * from "./GraduateApplicationStudentStatusSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports